:host {
  display: inline-block;
}

:host([embedded]) {
  width: var(--klevu-product-query-popup-width, 100%);
}
